import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  GET_PROMOTION_BY_ID,
  PROMOTION_ADD,
  PROMOTION_EDIT,
} from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import { createObjectURL } from "../../../../utilities/utilies";
import fileUploader from "../../../../utilities/fileUploader";

const schema = z.object({
  name: z.string().trim().min(1, { message: "Title is required" }),
});

const AddPromotion = () => {
  const { id } = useParams();
  const statusRef = useRef();
  const navigate = useNavigate();
  const [image, setImage] = useState(null);
  const [uploadedImage, setUploadedImage] = useState();

  const [promotionData, setPromotionData] = useState();
  const [activeInActive, setActiveInActive] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      name: promotionData?.name || "",
    },
    values: {
      name: promotionData?.name || "",
    },
  });

  const editHandler = async (id, data) => {
    try {
      if (!uploadedImage && !image) {
        return toast.error("please upload the image");
      }
      let url;
      if (image) {
        url = await fileUploader(image);

        if (!url) {
          return;
        }
      }

      const res = await PROMOTION_EDIT({
        name: data.name,
        promoId: id,
        status: statusRef?.current?.state?.checked ? "active" : "inactive",
        ...(image && { image: url }),
      });

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        setPromotionData(res?.data?.data);
        setActiveInActive(res?.data?.data?.status);
        navigate("/promotions");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const onsubmit = async (data) => {
    try {
      if (id) {
        editHandler(id, data);
        return; // return from here if it is edit mode
      }

      if (!image) {
        return toast.error("please upload  the image");
      }
      const url = await fileUploader(image);

      if (!url) {
        return;
      }

      const res = await PROMOTION_ADD({
        name: data.name,
        status: statusRef?.current?.state?.checked ? "active" : "inactive",
        image: url,
      });

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        navigate("/promotions");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const getPromotionData = async (id) => {
    try {
      const res = await GET_PROMOTION_BY_ID(id);
      if (res?.data?.status === "success") {
        setPromotionData(res?.data?.data[0]);
        setActiveInActive(res?.data?.data[0]?.status);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    if (id) {
      getPromotionData(id);
    }
  }, [id]);

  useEffect(() => {
    if (id) setUploadedImage(promotionData?.image);
  }, [promotionData?.image, id]);

  return (
    <>
      <section className="addPromotion py-3 position-relative">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12" className="my-2">
              <Link to="/promotions" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="40"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>
            <Col lg="9" className="my-2">
              <Form>
                <div className="formWrpper px-sm-4 box p-3 pb-5">
                  <Row>
                    <Col md="8" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        Title
                      </label>
                      <input
                        type="text"
                        className="form-control bg-white"
                        {...register("name")}
                      />
                      <p className="errorColor">
                        {errors?.name && errors.name.message}
                      </p>
                    </Col>
                    <Col md="4" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        Set Status of Promotion
                      </label>
                      <BootstrapSwitchButton
                        onlabel="Active"
                        onstyle="danger"
                        offlabel="Inactive"
                        offstyle="success"
                        width={147}
                        checked={activeInActive === "active" ? true : false}
                        ref={statusRef}
                        onChange={(e) => {
                          setActiveInActive(e ? "active" : "inactive");
                        }}
                      />
                    </Col>
                    <Col lg="12" className="my-2">
                      <label className="form-label m-0 fw-sbold text-muted ps-2 w-100">
                        <label className="form-label m-0 fw-sbold text-muted ps-2">
                          Upload Feature Image
                        </label>
                        <div
                          className="upload position-relative text-center p-3 bg-white rounded"
                          style={{ border: "1px dashed #ddd" }}
                        >
                          <span className="icn d-block mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="60"
                              height="60"
                              viewBox="0 0 100 100"
                              fill="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M50 65.625C50.8288 65.625 51.6237 65.2958 52.2098 64.7098C52.7958 64.1237 53.125 63.3288 53.125 62.5V16.7792L60.1251 24.95C60.6643 25.5799 61.4317 25.9698 62.2585 26.0339C63.0852 26.0979 63.9035 25.831 64.5334 25.2917C65.1633 24.7524 65.5531 23.985 65.6172 23.1583C65.6813 22.3316 65.4143 21.5133 64.875 20.8834L52.375 6.30004C52.0817 5.95698 51.7175 5.68155 51.3075 5.4927C50.8975 5.30385 50.4514 5.20605 50 5.20605C49.5487 5.20605 49.1026 5.30385 48.6926 5.4927C48.2826 5.68155 47.9184 5.95698 47.625 6.30004L35.125 20.8834C34.858 21.1953 34.6551 21.5567 34.5277 21.947C34.4004 22.3374 34.3512 22.749 34.3829 23.1583C34.4146 23.5677 34.5267 23.9668 34.7126 24.3328C34.8986 24.6989 35.1548 25.0247 35.4667 25.2917C35.7786 25.5587 36.14 25.7617 36.5304 25.889C36.9207 26.0164 37.3323 26.0656 37.7416 26.0339C38.151 26.0021 38.5501 25.8901 38.9161 25.7041C39.2822 25.5182 39.608 25.2619 39.875 24.95L46.875 16.7834V62.5C46.875 64.225 48.275 65.625 50 65.625Z"
                                fill="#A9A9A9"
                              />
                              <path
                                d="M66.6668 37.5C63.7418 37.5 62.2793 37.5 61.2252 38.2042C60.7719 38.5074 60.3826 38.8968 60.0793 39.35C59.3752 40.4042 59.3752 41.8667 59.3752 44.7917V62.5C59.3752 64.9864 58.3874 67.371 56.6293 69.1291C54.8711 70.8873 52.4866 71.875 50.0002 71.875C47.5138 71.875 45.1292 70.8873 43.371 69.1291C41.6129 67.371 40.6252 64.9864 40.6252 62.5V44.7917C40.6252 41.8667 40.6252 40.4042 39.921 39.35C39.6177 38.8968 39.2284 38.5074 38.7752 38.2042C37.721 37.5 36.2585 37.5 33.3335 37.5C21.5502 37.5 15.6543 37.5 11.996 41.1625C8.3335 44.8208 8.3335 50.7083 8.3335 62.4958V66.6625C8.3335 78.4542 8.3335 84.3417 11.996 88.0042C15.6543 91.6667 21.5502 91.6667 33.3335 91.6667H66.6668C78.4502 91.6667 84.346 91.6667 88.0043 88.0042C91.6668 84.3417 91.6668 78.45 91.6668 66.6667V62.5C91.6668 50.7125 91.6668 44.8208 88.0043 41.1625C84.346 37.5 78.4502 37.5 66.6668 37.5Z"
                                fill="#A9A9A9"
                              />
                            </svg>
                          </span>
                          <input
                            type="file"
                            className="d-none"
                            id="image"
                            onChange={(e) =>
                              setImage((p) => {
                                return e.target.files[0];
                              })
                            }
                          />

                          <div className="btnWrpper mt-3">
                            <div
                              className="d-inline-flex align-items-center justify-content-center commonBtn h-auto GreyBtn text-white px-2   py-1 rounded"
                              type="reset"
                            >
                              Browse or drop down
                            </div>
                          </div>
                        </div>
                      </label>
                    </Col>
                    <Col>
                      {(image || uploadedImage) && (
                        <div className="relative">
                          <span
                            onClick={() => {
                              setImage(null);
                              setUploadedImage(null);
                            }}
                          >
                            x
                          </span>
                          <img
                            src={
                              (image && createObjectURL(image)) || uploadedImage
                            }
                            style={{
                              width: "100px",
                              height: "100px",
                            }}
                          />
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
                <div className="btnWrpper mt-4 text-center">
                  <Button
                    className="d-inline-flex h-auto align-items-center justify-content-center commonBtn px-5"
                    type="button"
                    onClick={handleSubmit(onsubmit)}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddPromotion;
